import { Printer, Trash } from "@phosphor-icons/react";

/* Barra flutuante de ações em lote — só aparece quando há seleção.
   Fica fixed no bottom para não afetar a altura do header/tabela. */
export default function OrdersBulkBar({ selectedIds, canAdmin, onClear, onDelete }) {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-30 border-t-2 border-black bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.15)]"
      data-testid="bulk-action-bar"
    >
      <div className="px-4 md:px-8 py-3 flex items-center gap-3 flex-wrap justify-between">
        <div className="flex items-center gap-2">
          <span className="font-mono font-bold text-lg">{selectedIds.length}</span>
          <span className="text-xs text-zinc-500 uppercase tracking-widest">pedido{selectedIds.length > 1 ? "s" : ""} selecionado{selectedIds.length > 1 ? "s" : ""}</span>
          <button
            className="ml-2 text-xs text-zinc-500 hover:text-black underline"
            onClick={onClear}
            data-testid="bulk-clear-selection"
          >Limpar seleção</button>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <button
            className="btn btn-tight"
            style={{ background: "#002FA7", color: "white", borderColor: "#002FA7" }}
            onClick={() => {
              const ids = selectedIds.join(",");
              window.open(`/orders/print-batch?ids=${ids}`, "_blank");
            }}
            data-testid="bulk-print-btn"
          >
            <Printer size={14} weight="bold" />
            <span>Imprimir OP ({selectedIds.length})</span>
          </button>
          {canAdmin && (
            <button
              className="btn btn-tight"
              style={{ background: "#E60000", color: "white", borderColor: "#E60000" }}
              onClick={onDelete}
              data-testid="bulk-delete-btn"
            >
              <Trash size={14} weight="bold" />
              <span>Excluir ({selectedIds.length})</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
